import * as React from 'react';
import './index.css';
import { useParams } from 'react-router-dom';
import { ChatTextTile } from '../../components';
import { ArrowBackIcon, DeleteIcon, SendIcon } from '../../components/icons';
import { supabase } from '../../app/supabaseClient';

const ChatPage = () => {
    const [userMessage, setUserMessage] = React.useState('');
    const [chatData, setChatData] = React.useState([]);
    const bodyRef = React.useRef();
    const params = useParams();
    const id = params.from;
    const [user, setUser] = React.useState(Math.random() * 1000);
    const [message, setMessage] = React.useState();

    const getUser = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        console.log('user:', user);
        if (user) {
            setUser(user.id);
            console.log('logged in user:', user);
        } else {
            await anonymousUser();
            console.log('anonymous user:', user);
            // console.error('No user found');
        }
    }

    React.useEffect(() => {
        getUser();
        fetchMessageData().then(() => fetchChatData());
        // fetchChatData();
        realTimeChat();
    }, []);

    React.useEffect(() => {
        if (bodyRef.current) {
            bodyRef.current.scrollTo({
                top: bodyRef.current.scrollHeight + 115,
                behavior: 'smooth',
            });
        }
    }, [chatData]);

    const fetchMessageData = async () => {
        console.log('Fetching message data ');
        try {
            const { data, error } = await supabase
                .from('messages')
                .select('* , classifieds(title)')
                .eq('id', id)
                .single();
            if (error) throw error;
            setMessage(data);
        } catch (error) {
            console.error('Error fetching message data:', error);

        }
    }

    const fetchChatData = async () => {
        try {
            const { data, error } = await supabase
                .from('classified_chats')
                .select('*')
                .eq('message_id', id);
            if (error) throw error;
            setChatData(data || []);
        } catch (error) {
            console.error('Error fetching chat data:', error);
        }
    }

    console.log('Message chat test :', message);

    const sendMessage = async (e) => {
        e.preventDefault();
        const parsedMessage = userMessage.trim();
        if (!parsedMessage) return;

        setUserMessage('');
        const newUserMessage = {
            user_id: user,
            message: parsedMessage,
            date: new Date().toISOString(),
            message_id: message.id,
        };

        await addToSupabase(newUserMessage);
    };

    const addToSupabase = async (newMessage) => {
        try {
            const { data, error } = await supabase.from('classified_chats').insert([
                {
                    user_id: newMessage.user_id,
                    message: newMessage.message,
                    created_at: newMessage.date,
                    message_id: newMessage.message_id,
                },
            ]);
            if (error) throw error;
        } catch (error) {
            console.error('Error inserting message:', error);
        }
    };

    const realTimeChat = async () => {
        try {
            const subscription = supabase
                .channel('chat_channel')
                .on('postgres_changes',
                    { event: '*', schema: 'public', table: 'classified_chats', filter: `message_id=eq.${id}` },
                    async (payload) => {
                        // console.log('Change received!', payload);
                        console.log('payload.new:', payload.new);
                        setChatData((prev) => [...prev, payload.new]);
                    })
                .subscribe();

        } catch (error) {
            console.log('Error subscribing to chat:', error);
        }

    }

    // const deleteChatData = async () => {
    //     try {
    //         const { data, error } = await supabase
    //             .from('classified_chats')
    //             .delete()
    //             .eq('clientType', 'user');
    //         if (error) throw error;
    //         setChatData([]);
    //     } catch (error) {
    //         console.error('Error deleting chat data:', error);
    //     }
    // };

    const anonymousUser = async () => {
        try {
            const { user, error } = await supabase.auth.signInAnonymously({
                options: {
                    data: {
                        firstName: 'Anonymous',
                        lastName: 'User',
                    },
                    captchaToken: '03AGdBq27'
                },
            });
            if (error) throw error;
            console.log('Anonymous user signed in:', user);
        } catch (error) {
            console.error('Error signing in anonymously:', error);
        }
    }

    if (message && message.owner_id !== user && message.sender_id !== user) return 'You are not authorized to view this page';

    return (
        <section title="Chat test" className="chat-test-base container">
            <div className="chat-test-header">
                <ArrowBackIcon
                    size={15}
                    onClick={() => window.history.back()}
                    className="back-test-icon"
                />
                <span>{message?.classifieds?.title}</span>
                {/* <button onClick={deleteChatData} aria-label="Delete chat">
                    <DeleteIcon size={15} className="delete-test-icon" />
                </button> */}
            </div>
            <div className="chat-test-body" ref={bodyRef}>
                {chatData.map((data, index) => {
                    // console.log("Text data:", data, " isUser:", data.user_id === user);
                    return <ChatTextTile
                        key={index}
                        {...data}
                        isUser={data.user_id === user}
                        date={data.created_at ?? (new Date()).toISOString()}
                    />
                })}
            </div>
            <form className="chat-test-input-wrapper" onSubmit={sendMessage}>
                <input
                    className="chat-test-input"
                    placeholder="Enter your message"
                    value={userMessage}
                    onChange={(e) => setUserMessage(e.target.value)}
                    aria-label="Chat input"
                />
                <button
                    className="send-test-button"
                    type="submit"
                    aria-label="Send message"
                >
                    <SendIcon size={25} className="send-test-icon" />
                </button>
            </form>
        </section>
    );
};

export default ChatPage;

